import React from "react";
import { BsBraces, BsPersonBoundingBox } from "react-icons/bs";
import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt, BiData } from "react-icons/bi";
import { IoLogoYoutube } from "react-icons/io";
import FunFactCard from "./FunFactCard";

const FunFact = () => {
  return (
    <div className="px-0 grid grid-cols-2 md:grid-cols-4 pb-10">
      <FunFactCard icon={<BsPersonBoundingBox />} des="15 years experience" />
      <FunFactCard icon={<SiAntdesign />} des="20 Finished Projects" />
      <FunFactCard icon={<BiCodeAlt />} des="100 hours of coding" />
      <FunFactCard icon={<BiData />} des="oracle & SQL developer" />
    </div>
  );
};

export default FunFact;
